// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"580":"donations","594":"about"}[chunkId] + "." + {"580":"d441f1b2","594":"48564146"}[chunkId] + ".css";
};